export const DEFAULT_PRODUCT_CONFIG = {
  min_bin_qty: 10,
  max_bin_qty: 300,
};
